export default "__VITE_ASSET__42b2d20a__"